<template>
	<router-link
		ref="routerLink"
		custom
		v-slot="{ href, navigate, isActive }"
		:to="to">
		<a :href="href"
		   :class="[aClass, active(to) || isActive ? 'active' : '']"
		   v-bind="$attrs"
		   @click="navigate">
			<slot></slot>
		</a>
	</router-link>
</template>

<script>
export default {
	name: 'link-to',
	props: {
		to: {
			type: Object,
			required: true
		},
		aClass: {
			type: String,
			default: ''
		}
	},
	mounted() {
	},
	methods: {
		active(to) {
			return this.$route.name === to.name ||
				this.$route.path === to.path ||
				this.$route.fullPath === to.fullPath ||
				(this.$route.fullPath.indexOf(to.path) !== -1 && to.path !== '/');
		},
	}
}
</script>